import {Model} from "vue-mc";
import {Person} from "./Person";
import {Order} from "./Order";

export class Membership extends Model
{
    static TYPES = {
        SUPPORTING_MEMBER: 'supporting_member',
        ACTIVE_MEMBER: 'active_member',
    }

    static STATUS = {
        ACTIVE: 'active',
        CREATED: 'created',
        EXPIRED: 'expired',
        CANCELLED: 'cancelled',
    }

    defaults() {
        return {
            id: null,
            amount: 10,
            type: Membership.TYPES.SUPPORTING_MEMBER,
            startAt: '',
            endAt: '',
            cancelledAt: '',
            status: '',
            person: new Person(),
            order: new Order(),
        }
    }
}
